module.exports = __webpack_public_path__ + "static/media/geotolk-12.81414c96.svg";